/* eslint-disable import/no-named-default */
/* eslint-disable import/prefer-default-export */
import {
  StyleExtender as StyleExtenderImpl,
  StyleObjectType,
  DEFAULT_CSS_PROPERTY_NAMES,
  DEFAULT_CSS_VARIABLE_POSTFIXES,
} from '@scripts/utils/style-extender';

export class StyleExtender {
  impl: StyleExtenderImpl;

  constructor({
    propertyNames = [...DEFAULT_CSS_PROPERTY_NAMES],
    extraPropertyNames = [],
    variablePrefix,
    variablePostfixes = [...DEFAULT_CSS_VARIABLE_POSTFIXES],
    extraVariablePostfixes = [],
  }: {
    propertyNames: Array<string>,
    extraPropertyNames: Array<string>,
    variablePrefix: string,
    variablePostfixes: Array<string>,
    extraVariablePostfixes: Array<string>,
  }) {
    this.impl = new StyleExtenderImpl({
      propertyNames,
      extraPropertyNames,
      variablePrefix,
      variablePostfixes,
      extraVariablePostfixes,
    });
  }

  extend({
    target,
    extension,
    selector,
  }: {
    target: StyleObjectType,
    extension: StyleObjectType,
    selector: string,
  }): void {
    this.impl.extend({ target, extension, selector });
  }
}
